//src/asset/textData/texts.js

const texts = [
    "Has comido?",
    "Have you eaten?",
    "As-tu mangé ?",
    "Hast du gegessen?",
    "Hai mangiato?",
    "Het jy geëet?",
    "Ṣé o ti jẹun?",
    " هل أكلت؟",
    "Você comeu?"
];

export default texts;
